import { Action } from "redux";

export interface PasswordResetDataReducerState {
    lastRequest?: number,
    token: string
};

const initialState: PasswordResetDataReducerState = {
    lastRequest: null,
    token: null
};

interface PasswordResetDataAction extends Action {
    lastRequest?: number,
    token: string
};

export const passwordResetReducer = (
    state: PasswordResetDataReducerState = initialState,
    action: PasswordResetDataAction
): PasswordResetDataReducerState => {
    switch (action.type) {
        case 'SET_LAST_RQ_TIMESTAMP': 
            return { 
                ...state,
                lastRequest: action.lastRequest
            };
        case 'SET_PW_RESET_DATA': 
            return {
                ...state,
                lastRequest: action.lastRequest,
                token: action.token
            }
        default: 
            return state;
    }
};

export const setLastRqTimestamp = (lastRequest: number) => ({
    type: 'SET_LAST_RQ_TIMESTAMP',
    payload: {
        lastRequest: lastRequest,
        token: null
    }
});

export const setPwResetData = (data: PasswordResetDataReducerState) => ({
    type: 'SET_LAST_RQ_TIMESTAMP',
    payload: data
});

